import React, { forwardRef, useState } from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  isValid?: boolean;
  icon?: React.ReactNode;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ isValid, disabled, className, value, onChange, onFocus, onBlur, icon, ...props }, ref) => {
    const [isFocused, setIsFocused] = useState(false);

    const baseClasses = `
      flex h-[50px] items-center self-stretch 
      border rounded-[2px] w-full transition-colors outline-none 
    `;

    let stateClasses = '';

    const stringValue = typeof value === 'string' ? value : '';

    if (disabled) {
      stateClasses = 'bg-[#F2F2F2] border-[#DCDCDC] text-text_sub font-normal text-[14px]';
    } else if (isValid === false && value === '') {
      stateClasses = 'bg-transparent border-[#FF4555] text-text_sub font-normal text-[14px]';
    } else if (!isFocused) {
      stateClasses = 'bg-transparent border-[#DCDCDC] text-text_sub font-normal text-[14px]';
    } else {
      stateClasses = 'bg-transparent border-[#1D6CEB] text-white font-normal text-[14px]';
    }

    const handleClear = () => {
      const event = {
        target: { value: '' },
      } as React.ChangeEvent<HTMLInputElement>;

      onChange?.(event);
    };

    return (
      <div className="relative w-full">
        <input
          ref={ref}
          disabled={disabled}
          value={value}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          className={`${baseClasses} ${className ?? ''} ${stateClasses} ${icon ? 'pr-10' : ''}`}
          {...props}
        />
        {/* SKIX UX 에서는 input 에 삭제 버튼 표시 안함. */}
        {/* {isFocused && stringValue.length > 0 && (
          <button type="button" onClick={handleClear} className="absolute right-3 top-1/2 -translate-y-1/2">
            <IconClear />
          </button>
        )} */}
        <button type="button" onClick={handleClear} className="absolute right-0 top-1/2 -translate-y-1/2">
          {icon}
        </button>
      </div>
    );
  },
);

Input.displayName = 'Input';

export default Input;
